// extracted by css-extract-rspack-plugin
export default {"root":"SOpRyO","heading-and-description":"rXkIjT","headingAndDescription":"rXkIjT","footer":"y2xQ3n"};